import {useRessourceState} from "@web-libs/core/ressources/use-ressource-state";
import {useRef} from "react";

type FetchFunction<T> = () => Promise<T>;
export const useRessource = <T>() => {
    const  currentOperation = useRef<number>(0)
    const {
        isLoading,
        setIsLoading,
        error,
        setError,
    } = useRessourceState()

    const fetchRessource = async (fetch:FetchFunction<T>,onSuccess:(data:T)=>void, errorMessage:string) => {
        setIsLoading(true);
        const operationId = ++currentOperation.current
        const result:{data:T|undefined, error:string|undefined} = {data:undefined, error:undefined}
        try {
            result.data = await fetch()
        } catch {
            result.error = errorMessage
        }
        if (operationId !== currentOperation.current) return
        if(result.error) {
            setError(result.error);
        } else if(result.data) {
            onSuccess(result.data)
        }
        setIsLoading(false);
    }

    return {
        isLoading,
        error,
        fetchRessource
    }
}
